import React from 'react';
import { IconButton } from '@mui/material';
import logowhatsapp from 'assets/images/logo-whatsapp.png';
import useWhatsAppUrl from '../../hooks/useWhatsAppUrl';

const WhatsAppIconButton = ({ 
  packageUrlWhatsapp = null,
  productName = null,
  productRefNumber = null,
  sx = {}, 
  className = '',
  iconSize = 24 
}) => {
  const { whatsappUrl, isBusiness } = useWhatsAppUrl(
    packageUrlWhatsapp,
    productName,
    productRefNumber
  );
  
  const defaultSx = {
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: '#25D366',
    color: 'white',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#25D366',
      transform: 'translateY(-2px)',
    },
    '&.Mui-disabled': {
      backgroundColor: '#cccccc',
    },
    ...sx,
  };
  
  return (
    <IconButton
      component={whatsappUrl ? "a" : "button"}
      href={whatsappUrl || undefined}
      target={whatsappUrl ? "_blank" : undefined}
      rel={whatsappUrl ? "noopener noreferrer" : undefined}
      disabled={!whatsappUrl}
      className={className}
      sx={defaultSx}
      aria-label={isBusiness ? "Contactar por WhatsApp Business" : "Contactar por WhatsApp"}
    >
      <img 
        alt={isBusiness ? "WhatsApp Business" : "WhatsApp"} 
        src={logowhatsapp} 
        style={{ width: iconSize, height: iconSize }} 
      />
    </IconButton>
  );
};

export default WhatsAppIconButton;

